import { DownloadIcon } from "@heroicons/react/outline";
import { DotsHorizontalIcon } from "@heroicons/react/solid";
import React, { useState, useEffect } from "react";
import Table from "../../../parts/table/Table";

const HasilKuisDetailFile = (props) => {
  const [data, setdata] = useState(props.dataSoal ?? []);
  let staticCol = [
    {
      Header: "No",
      accessor: "id",
      Cell: ({ row }) => {
        return <p>{row.index + 1}</p>;
      },
    },
    {
      Header: "Username",
      accessor: "username",
    },
    {
      Header: "Nama User",
      accessor: "nama",
    },
    {
      Header: "file",
      id: "jawaban",
      accessor: "jawaban",
      Cell: ({ row }) => {
        return (
          <div className="flex items-center justify-center">
            <a
              href={row.original.jawaban}
              download
              target="_blank"
              className="p-2 rounded-full bg-blue-300"
            >
              <DownloadIcon className="h-4 w-4" />
            </a>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    // pushSkala1();
  }, []);

  return (
    <div
      className="w-full flex flex-col py-10 dark:text-white"
      style={{ minHeight: "100vh" }}
    >
      <Table columns={staticCol} data={data} />
    </div>
  );
};

export default HasilKuisDetailFile;
